<template>
  <v-container>
    <div class="mt-4">
      <v-card elevation="0">
        <v-col cols="12">
          <h2 class="text-left pt-3">
            {{ layout !== 'correction' ? languageData.invoice.invoice : 'Gutschrift' }} {{ invoiceNumber }}
          </h2>
        </v-col>
        <v-form ref="invoiceForm" v-model="invoiceForm">
          <v-card-text class="invoiceBody">
            <v-row justify="space-between">
              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12" style="padding-top: 0 !important; padding-bottom: 0 !important">
                <v-select
                    v-model="invoice.type"
                    :items="invoiceTypes"
                    :rules="rules.type"
                    :label="languageData.labelsInvoice.selectInvoiceType"
                    :disabled="isInputDisabled()"
                    return-object
                    outlined
                    @change="selectInvoiceType($event)"
                    :retain-focus="false"
                >
                  <template slot='selection' slot-scope='{ item }'>
                    {{ languageData.invoiceTypes[item.value] }}
                  </template>
                  <template slot='item' slot-scope='{ item }'>
                    {{ languageData.invoiceTypes[item.value] }}
                  </template>
                </v-select>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 9 : 12" style="padding-top: 0 !important; padding-bottom: 0 !important">
                <v-row class="justify-end">
                  <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                    <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="invoice.date"
                            :label="languageData.labelsInvoice.invoiceDate"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            :rules="rules.date"
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            :disabled="isInputDisabled()"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="invoice.date"
                          no-title
                          scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="menu1 = false"
                        >
                          {{ languageData.cancel }}
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu1.save(invoice.date)"
                        >
                          {{ languageData.btnAgreeText }}
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row justify="space-between" class="mb-1">
              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12" style="padding-top: 0 !important; padding-bottom: 0 !important">
                <v-select
                    v-if="needProjectSelect || (invoice.type && invoice.type.value === this.invoiceTypeEnum.find(el => el.name === 'NORMAL_INVOICE').value)"
                    v-model="invoice.project"
                    :items="projects"
                    @change="getProjectInfo"
                    :rules="rules.project"
                    item-text="name"
                    item-value="id"
                    :label="languageData.labelsInvoice.select_project"
                    return-object
                    outlined
                    :disabled="isInputDisabled()"
                    :retain-focus="false"

                >
                </v-select>
                <v-tooltip top :disabled="layout !== 'correction' && this.layout !== 'edit' ? recipients.length > 0 : true">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <v-select
                      v-if="(!needProjectSelect || typeof(invoice.project) == 'object') || (invoice.type && invoice.type.value === this.invoiceTypeEnum.find(el => el.name === 'NORMAL_INVOICE').value)"
                      v-model="invoice.client"
                      :items="layout !== 'correction' ? recipients : correctionRecipients"
                      :rules="rules.client"
                      :no-data-text="languageData.invoiceValidation.noClientsData"
                      item-text="name"
                      item-value="id"
                      :label="languageData.labelsInvoice.selectRecipient"
                      return-object
                      outlined
                      :disabled="isInputDisabled()"
                      :retain-focus="false"
                      >
                      </v-select>
                    </span>  
                  </template>
                  <span>{{ languageData.invoiceValidation.noClientsData }}</span>
                </v-tooltip>
                
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 9 : 12" style="padding-top: 0 !important; padding-bottom: 0 !important">
                <v-row justify="end">
                  <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12" style="padding-bottom: 0 !important">
                    <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="invoice.sellFrom"
                            :label="languageData.labelsInvoice.sellFrom"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            :rules="rules.sellFrom"
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            :disabled="isInputDisabled()"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="invoice.sellFrom"
                          no-title
                          scrollable
                          outlined
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="menu2 = false"
                        >
                          {{ languageData.cancel }}
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu2.save(invoice.sellFrom)"
                        >
                          {{ languageData.btnAgreeText }}
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12" :style="$vuetify.breakpoint.mdAndUp ? 'padding-bottom: 0 !important' : 'padding-top: 0 !important'">
                    <v-menu
                        ref="menu3"
                        v-model="menu3"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="invoice.sellTo"
                            :label="languageData.labelsInvoice.sellTo"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            :rules="rules.sellTo"
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            :disabled="isInputDisabled()"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="invoice.sellTo"
                          no-title
                          scrollable
                          outlined

                      >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="menu3 = false"
                        >
                          {{ languageData.cancel }}
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu3.save(invoice.sellTo)"
                        >
                          {{ languageData.btnAgreeText }}
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12" v-if="layout !== 'correction' && invoice.type && invoice.type.value !== this.invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value " style="padding-top: 0 !important; padding-bottom: 0 !important">
                <v-select
                    v-if="invoice.type.value !== this.invoiceTypeEnum.find(el => el.name === 'NORMAL_INVOICE').value"
                    v-model="invoice.payment"
                    :items="isInputDisabled ? project.invoicePayments : invoicePayments"
                    :rules="rules.payment"
                    :label="languageData.invoicePayments.addPaymentTermin"
                    return-object
                    outlined
                    item-text="name"
                    item-value="id"
                    :retain-focus="false"
                >
                  <template slot='selection' slot-scope='{ item }'>
                    {{ item.days }} {{ languageData.invoicePayments.days }} &ndash; {{ item.discount }}% {{ languageData.invoicePayments.discount }}
                  </template>
                  <template slot='item' slot-scope='{ item }'>
                    {{ item.days }} {{ languageData.invoicePayments.days }} &ndash; {{ item.discount }}% {{ languageData.invoicePayments.discount }}
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-divider>
            </v-divider>
            <InvoiceItemsTable v-if="projectData !== null && invoice.type" :invoiceType="invoice.type.value" :projectData="projectData" :layout="layout"  :invoicePayment="invoice.payment" />
            <InvoiceItemsTable
                v-if="(projectData === null && typeof(invoice.project) === 'object' || (invoice.type && invoice.type.value === this.invoiceTypeEnum.find(el => el.name === 'NORMAL_INVOICE').value)) && invoice.type"
                :projectData="invoice.project"
                :invoicePayment="invoice.payment"
                :invoiceItemsData="invoice.invoiceItems"
                :layout="layout"
                :invoiceType="invoice.type.value"
            />
            <v-card-actions class="mt-5">
              <v-row justify="end" no-gutters>
                <v-btn
                    color="primary"
                    class="button-shadow"
                    @click="showSaveConfirmationModal"
                    :loading="dataSaveIsFetching"
                    :disabled="this.layout === 'edit' ? false : isSaveButtonDisabled"
                >
                  <v-icon class="mr-2">mdi-arrow-right</v-icon>
                  {{ languageData.invoice.btnSave }}
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card-text>
        </v-form>
      </v-card>
    </div>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideModalSendInvoice"  :show-modal="isModalSendInvoiceVisible">
      <template v-slot:header>
        {{ languageData.labels.sendInvoice}}
      </template>
      <template v-slot:body>
        <v-row justify="center">
           <v-btn
              color="primary"
              class="button-shadow mr-3"
              @click="showInvoicePersons"
              :loading="dataStoreAndSendIsFetching">
              {{ languageData.choosePersonAndSend }}
           </v-btn>
           <v-btn
              color="primary"
              class="button-shadow"
              @click="showEmailForm"
              :loading="dataStoreAndSendIsFetching">
              {{ languageData.typeEmailAndSend }}
           </v-btn>
        </v-row>
      </template>
    </ModalInfo>
    <ModalInfo
      v-if="languageData.projectInvoicesNotConfirmedModal && isVisibleWarningModalNotInProjectEdition"
      @doOperation="handleWarningModal"
      :isLoadingBtn="false"
      :typeInfo="'info'"
      :headModal="languageData.projectInvoicesNotConfirmedModal.head"
      :btnDisAgreeText="languageData.projectInvoicesNotConfirmedModal.btnDisAgreeText"
      :btnAgreeText="languageData.projectInvoicesNotConfirmedModal.btnAgreeText"
      :visDisAgreeBtn="true" @clicked="hideWarningModal"
      :show-modal="isVisibleWarningModalNotInProjectEdition"
      :text-modal="languageData.projectInvoicesNotConfirmedModal.textInfo">
    </ModalInfo>
    <ModalInfo
      v-if="languageData.projectInvoicesNotConfirmedModal && isVisibleWarningModalInProjectEdition"
      @doOperation="redirectToProjectsList"
      :isLoadingBtn="false"
      :typeInfo="'info'"
      :headModal="languageData.projectInvoicesNotConfirmedModal.head"
      :btnDisAgreeText="languageData.projectInvoicesNotConfirmedModal.btnDisAgreeText"
      :btnAgreeText="languageData.projectInvoicesNotConfirmedModal.btnAgreeText2"
      :visDisAgreeBtn="true" @clicked="hideWarningModalInProjectEdition"
      :show-modal="isVisibleWarningModalInProjectEdition"
      :text-modal="languageData.projectInvoicesNotConfirmedModal.textInfo2">
    </ModalInfo>
    <ModalInfo
        v-if="isConfirmSaveModalVisible"
        @doOperation="confirmSaveInvoice"
        @clicked="cancelSaveInvoice"
        :isLoadingBtn="false"
        :typeInfo="'info'"
        :headModal="languageData.labels.confirmHeadSave"
        :btnAgreeText="languageData.invoice.btnSave"
        :btnDisAgreeText="languageData.projectInvoicesNotConfirmedModal.btnDisAgreeText"
        :visDisAgreeBtn="true"
        :show-modal="isConfirmSaveModalVisible"
        :text-modal="languageData.labels.confirmSave">
    </ModalInfo>
  </v-container>
</template>

<style src="./Invoice.scss" lang="scss"></style>


<script>
import InvoiceItemsTable from "../InvoiceItemsTable/InvoiceItemsTable";
import invoiceTypeEnum from "../../enums/invoiceTypeEnum";
import {mapActions, mapState} from "vuex";
import eventBus from "../../../../event-bus/eventBus";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import handleFormError from "../../../../helpers/handleFormError";

export default {
  name: 'Invoice',
  components: {ModalInfo, InvoiceItemsTable},
  props: {
    projectData: {
      type: Object,
      required: false,
      default: null
    },
    layout: String,
    modelType: String,
  },
  data() {
    return {
      menu1: false,
      menu2: false,
      menu3: false,
      invoiceTypeEnum: invoiceTypeEnum,
      invoiceTypes: [],
      menuInvoiceDate: false,
      menuInvoiceSellTo: false,
      MenuInvoiceSellFrom: false,
      invoice: {
        project: '',
        client: '',
        type: null,
        date: '',
        sellFrom: '',
        sellTo: '',
        invoiceItems: [],
        payment: null,
      },
      correctionRecipients: [],
      invoiceItemsData: [],
      validForm: false,
      invoiceForm: false,
      rules: {},
      needProjectSelect: false,
      isShowInvoicePaymentsTable: false,
      isConfirmSaveModalVisible: false,
    }
  },
  watch: {
    invoiceLoaded(val) {
      if(val) {
        this.prepareInvoiceData();
      }
    },
  },
  computed: {
    ...mapState("getRecipients", {
      recipients: state => state.recipients,
    }),
    ...mapState("getInvoiceNumber", {
      invoiceNumber: state => state.invoiceNumber
    }),
    ...mapState("saveInvoice", {
      dataSaveIsFetching: state => state.dataSaveIsFetching,
      dataStoreAndSendIsFetching: state => state.dataStoreAndSendIsFetching,
      isModalSendInvoiceVisible: state => state.isModalSendInvoiceVisible,
      invoiceId: state => state.invoiceId,
    }),
    ...mapState("updateVisibleInvoiceClientPersonsModal", {
      isShowInvoiceClientPersonsModal: state => state.isShowInvoiceClientPersonsModal
    }),
    ...mapState("getCompanyUser", {
      user: state => state.dataReceive
    }),
    ...mapState("getProjects", {
      projects: state => state.dataReceive,
    }),
    ...mapState("getProject", {
      project: state => state.dataReceive,
    }),
    ...mapState("getInvoice", {
      dataReceive: state => state.dataReceive,
      invoiceLoaded: state => state.invoiceLoaded,
    }),
    ...mapState("isProjectInvoicesConfirmed", {
      areProjectInvoicesConfirmed: state => state.areProjectInvoicesConfirmed,
      isVisibleWarningModalNotInProjectEdition: state => state.isVisibleWarningModalNotInProjectEdition,
      isVisibleWarningModalInProjectEdition: state => state.isVisibleWarningModalInProjectEdition,
    }),
    invoicePayments() {
      if(this.invoice.type) {
        return this.project.invoicePayments.filter(el => el.invoiceType === this.invoice.type.value);
      }
      return [];
    },
    isSaveButtonDisabled() {
      if ((this.areProjectInvoicesConfirmed || (this.invoice.type && this.invoice.type.value === this.invoiceTypeEnum.find(el => el.name === 'NORMAL_INVOICE').value)) && this.invoice.type && this.invoice.client) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    ...mapActions("saveInvoice", ["storeInvoice", "updateVisibleModal", "storeInvoiceAndSend", 'hideSendInvoiceModalRequest']),
    ...mapActions("getInvoiceNumber", ["getInvoiceNumber"]),
    ...mapActions("getRecipients", ["getRecipients"]),
    ...mapActions("getHeadersInvoiceItems", ["getHeadersInvoiceItems"]),
    ...mapActions("getHeadersInvoicePayments", ["getHeadersInvoicePayments"]),
    ...mapActions("getProjects", ["getProjects"]),
    ...mapActions("updateVisibleInvoiceClientPersonsModal", ["updateVisibleInvoiceClientPersonsModal"]),
    ...mapActions("updateVisibleInvoiceSendEmailModal", ["updateVisibleInvoiceSendEmailModal"]),
    ...mapActions("getInvoiceClientPersons", ["getInvoiceClientPersons"]),
    ...mapActions("sendInvoice", ["prepareInvoice"]),
    ...mapActions("getInvoice", ["getInvoice"]),
    ...mapActions("getVat", ["getVat"]),
    ...mapActions("updateInvoice", ["updateInvoiceRequest"]),
    ...mapActions("isProjectInvoicesConfirmed", ["checkAreProjectInvoicesConfirmedRequest", "updateVisibleWarningModalNotInProjectEdition", "updateVisibleWarningModalInProjectEdition"]),
    ...mapActions("updateVisibleCreateInvoiceModal", ["updateVisibleCreateInvoiceModal"]),

    redirectToProjectsList() {
      this.updateVisibleCreateInvoiceModal(false);
      this.$router.push({name: 'ProjectsList'});
    },

    hideModalSendInvoice() {
      this.hideSendInvoiceModalRequest(false);
      this.updateVisibleCreateInvoiceModal(false);   
      if (this.$route.name === 'InvoiceList') {
        eventBus.$emit('hideModalSendInvoice');
      }
    },

    hideInvoiceModal() {
      this.updateVisibleModal(false);
    },

    hideWarningModal() {
      this.updateVisibleWarningModalNotInProjectEdition(false);
    },

    hideWarningModalInProjectEdition() {
      this.updateVisibleWarningModalInProjectEdition(false);
    },

    handleWarningModal() {
      this.updateVisibleCreateInvoiceModal(false);
      this.$emit('closeInvoiceCorrectionEventFromChild', false);
    },

    saveInvoice() {
      this.rules = [];
      if (this.invoice.id === undefined || (this.layout === 'edit' && this.invoice.type.value !== this.invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value)) {
        this.invoice.invoiceCorrectionId = null
      } else if (this.invoice.id !== undefined && this.layout !== 'edit') {
        this.invoice.invoiceCorrectionId = this.invoice.id;
      }
      this.$refs.invoiceForm.resetValidation();
      if(this.layout === 'correction' || this.invoice.type.value === this.invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value ) {
        this.invoice.modelType = this.modelType;
        this.invoice.invoiceItems.filter((el) => {
          if(typeof(el.vat) !== 'object') {
            el.vat = {
              value: el.vat,
            };
          }
          if(typeof(el.uom) !== 'object') {
            el.uom = {
              value: el.uom
            }
          }
        });
      }
      if(this.modelType === 'invoice') {
        this.invoice.modelType = this.modelType;
      }
      if (this.layout === 'edit') {
        this.updateInvoiceRequest({creds: this.invoice});
      } else {
        this.storeInvoice({creds: this.invoice});
      }
      
    },
    saveInvoiceAndSend() {
      this.rules = [];
      this.invoice.invoiceCorrectionId = this.invoice.id === undefined ? null : this.invoice.id;
      this.$refs.invoiceForm.resetValidation();
      if(this.modelType === 'invoice') {
        this.invoice.modelType = this.modelType;
      }
      this.storeInvoiceAndSend({creds: this.invoice});
    },
    showInvoicePersons() {
      const id = this.invoiceId;
      this.getInvoiceClientPersons({ creds: { id } });
      this.prepareInvoice({id});
      this.updateVisibleInvoiceClientPersonsModal(true);
      this.hideSendInvoiceModalRequest(false);
    },
    showEmailForm() {
      const id = this.invoiceId;
      this.prepareInvoice({id});
      this.updateVisibleInvoiceSendEmailModal(true);
      this.hideSendInvoiceModalRequest(false);
    },
    resetInputs() {
      this.invoice = {
        date: '',
        sellForm: '',
        sellTo: '',
        type: '',
        client: '',
        payment: null,
      }
    },
    isInputDisabled() {
      if (this.layout === 'correction') {
        return true;
      } else if (this.invoice.type && this.invoice.type.value === this.invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value) {
        return true
      } else {
        return false;
      }
    },
    getProjectInfo() {
      this.checkAreProjectInvoicesConfirmedRequest({projectId: this.invoice.project.id})
      this.getRecipients(this.invoice.project.id);
      this.project.invoicePayments = this.invoice.project.invoicePayments;
    },
    selectInvoiceType(event) {
      if(event.value === this.invoiceTypeEnum.find(el => el.name === 'NORMAL_INVOICE').value) {
        this.needProjectSelect = false;
        this.getRecipients(0);
      } else {
        this.needProjectSelect = true;
      }
      this.getInvoiceNumber({invoiceType: event.value});
    },
    prepareInvoiceData() {
      if (this.layout === 'edit') {     
        this.invoice = this.dataReceive;
        this.invoice.type = this.invoiceTypeEnum.find(el => el.value === this.invoice.type);
        if (this.invoice.type.value === this.invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value) {
          this.invoiceTypes.push(this.invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE'));      
        }

        if(this.invoice.project) {
          this.getRecipients(this.invoice.project.id);
          this.project.invoicePayments = this.dataReceive.project.invoicePayments;
        } else {
          this.getRecipients(0);
        }
        this.getInvoiceNumber({invoiceType: this.invoice.type.value});
      } else if (this.layout === 'correction') {
        this.invoice = this.dataReceive;
        this.invoiceTypes = [];
        this.invoice.type = this.invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE');
        this.project.invoicePayments = this.dataReceive.project.invoicePayments
        this.invoiceTypes.push(this.invoice.type);
        this.correctionRecipients.push(this.invoice.client);
        this.checkAreProjectInvoicesConfirmedRequest({projectId: this.invoice.project.id})
      }
    },
    showSaveConfirmationModal() {
      this.isConfirmSaveModalVisible = true;
    },

    confirmSaveInvoice() {
      this.isConfirmSaveModalVisible = false;
      this.saveInvoice();

      this.$router.push('/invoices');
    },

    cancelSaveInvoice() {
      this.isConfirmSaveModalVisible = false;
    }

  },
  mounted() {
    this.getVat();
    if (this.invoice.type) {
      this.getInvoiceNumber({invoiceType: this.invoice.type});
    } else if(this.layout === 'correction') {
      this.getInvoiceNumber({invoiceType: this.invoiceTypeEnum.filter(item => item.name === 'CORRECTIVE_INVOICE')[0].value });
    } else if (this.layout !== 'edit') {
      this.getInvoiceNumber();
    }

    if(this.projectData === null) {
      this.needProjectSelect = true;
      this.getProjects({
          all: true
      });
    } else {
      if (this.projectData.id) {
        this.getRecipients(this.projectData.id);
      }   
      if (this.layout !== 'edit' && this.layout !== 'correction') {
        this.checkAreProjectInvoicesConfirmedRequest({projectId: this.projectData.id})
      } 
    }

    this.invoiceTypes = this.invoiceTypeEnum.filter(item => item.name !== 'CORRECTIVE_INVOICE');

    const language = this.getCurrentLanguage;
    this.getHeadersInvoiceItems({ creds: { language } });
    this.getHeadersInvoicePayments({ creds: { language } });

    eventBus.$on("getRecipientsSuccess", (data) => { 
      data.length > 0 ? this.invoice.client = data[0] : '';
    });
    
    eventBus.$on("saveInvoiceSuccess", () => {
      this.resetInputs();
      this.invoiceTypes = this.invoiceTypeEnum.filter(item => item.name !== 'CORRECTIVE_INVOICE');
      this.getInvoiceNumber();
    });
    eventBus.$on("sendInvoiceSuccess", () => {
      this.resetInputs();
      this.invoiceTypes = this.invoiceTypeEnum.filter(item => item.name !== 'CORRECTIVE_INVOICE');
      this.updateVisibleInvoiceClientPersonsModal(false);
      this.updateVisibleInvoiceSendEmailModal(false);
    });

    eventBus.$on("saveInvoiceFailure", (errorsData) => {
      this.rules = handleFormError(errorsData);
      this.validForm = this.$refs.invoiceForm.validate();
    });

    eventBus.$on("closeCorrectionInvoice", () => {
      this.invoice = {};
      this.invoiceTypes = this.invoiceTypeEnum.filter(item => item.name !== 'CORRECTIVE_INVOICE');
    });
  },
};

</script>

